import { StyleSheet } from 'react-native';

import { smallPaddingBox } from '../view-style';

export default StyleSheet.create({
  button: {
    alignItems: 'flex-end',
    zIndex: 1,
    paddingTop: 10,
    marginBottom: -15,
    marginRight: 25,
    marginLeft: -25,
  },
  text: {
    ...smallPaddingBox,
  },
});
